<template>
    <span class="label" :class="className">
        {{ text }}
    </span>
</template>

<script>
    export default {
        props: ['opportunity'],
        
        computed: {
            text() {
                if (this.opportunity.status === 'open') {
                    return 'Open'
                }

                if (this.opportunity.status === 'missed') {
                    return 'Missed'
                }

                if (this.opportunity.status === 'converted') {
                    return 'Converted'
                }

                return 'Unknown'
            },

            className() {
                if (this.opportunity.status === 'open') {
                    return 'label-info'
                }

                if (this.opportunity.status === 'missed') {
                    return 'label-danger'
                }

                if (this.opportunity.status === 'converted') {
                    return 'label-success'
                }

                return 'label-primary'
            }
        }
    }
</script>